"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableRowsPerPageOptions = exports.ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE = exports.ColumnId = exports.DATE_TIME_FORMAT_DASH = exports.SEARCH_QUERY_UPDATE_DELAY = exports.NUMBER_NOT_USE_LAZY_LOAD = exports.TAXONOMY_CLASS_V2_ID = void 0;
const store_1 = require("./store");
exports.TAXONOMY_CLASS_V2_ID = '00000000-0000-0000-0000-0000000019c3';
exports.NUMBER_NOT_USE_LAZY_LOAD = 50;
exports.SEARCH_QUERY_UPDATE_DELAY = 250;
exports.DATE_TIME_FORMAT_DASH = 'yyyy-MM-dd HH:mm:ss';
var ColumnId;
(function (ColumnId) {
    ColumnId["CuratedAttributes"] = "curatedAttributes";
})(ColumnId || (exports.ColumnId = ColumnId = {}));
exports.ENRICH_STATE_PATHS_TO_PERSIST_IN_LOCAL_STORAGE = [
    `${store_1.ENRICH_REDUX_SLICE_KEY}.organizations.selectedOrganizationsIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.includedCategoriesIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.excludedCategoriesIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.includedTaxonomyClassIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.excludedTaxonomyClassIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.includedAttributesIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.excludedAttributesIds`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.productFilterActive`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.products.productFilterResults`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.facetNavigationPanel.searchTerm`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.facetNavigationPanel.openCategories`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.facetNavigationPanel.openAttributes`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.facetNavigationPanel.openTaxonomyClasses`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.selectedCatalog.id`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.selectedProject.id`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.selectedTreeNodePath`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.changes`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.aggregatedAttributes`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.selectedAttributeNode`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.expandedNodes`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.isAggregatedAttributeViewHidden`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.isListViewMode`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.pageSize`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.selectedEntities.search`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.productTreeFilters`,
    `${store_1.ENRICH_REDUX_SLICE_KEY}.enrichAI.catalogs`,
];
exports.tableRowsPerPageOptions = [10, 20, 30];
